import { useQuery } from '@tanstack/react-query'
import { useCallback, useState } from 'react'

import { UsePaginatedQueryProps } from './types.ts'

export function usePaginatedQuery<
  TResponse extends { count: number }
>({
  queryKey,
  fetcher,
  initialPage = 1,
  pageSize = 10,
  filterParams,
  enabled = true
}: UsePaginatedQueryProps<TResponse>) {
  const [currentPage, setCurrentPage] = useState<number>(initialPage)

  const query = useQuery<TResponse | null, Error>({
    queryKey: [...queryKey, currentPage, filterParams],
    queryFn: (): Promise<TResponse | null> =>
      fetcher({ page: currentPage, filterParams }),
    enabled
  })

  const totalPages = query.data?.count
    ? Math.ceil(query.data.count / pageSize)
    : 1

  const goToPage = useCallback((page: number) => {
    setCurrentPage(page)
  }, [])


  return {
    ...query,
    currentPage,
    goToPage,
    totalPages,
    setCurrentPage
  }
}